/**
 * @generated SignedSource<<51bcd10166d1559c90d155833659d289>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecordWithUrlButton_viewer$data = {
  readonly hasAccessToCopilot: boolean;
  readonly remainingMeetingRecordingCredits: number;
  readonly " $fragmentSpreads": FragmentRefs<"LibraryHooksUseOpenChannelsModal_viewer" | "featureFlag_useCopilotPaywallsOn_viewer">;
  readonly " $fragmentType": "RecordWithUrlButton_viewer";
};
export type RecordWithUrlButton_viewer$key = {
  readonly " $data"?: RecordWithUrlButton_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecordWithUrlButton_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecordWithUrlButton_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingMeetingRecordingCredits",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAccessToCopilot",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LibraryHooksUseOpenChannelsModal_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "featureFlag_useCopilotPaywallsOn_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b3a1fc22fec8eb410ace472ebde44a09";

export default node;
